import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '/login', component: () => import('../views/Login.vue') },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '首页统计' } },
      { path: 'product-add', component: () => import('../views/ProductAdd.vue'), meta: { title: '产品录入' } },
      { path: 'product-list', component: () => import('../views/ProductList.vue'), meta: { title: '产品列表' } },
      { path: 'accessory-add', component: () => import('../views/AccessoryAdd.vue'), meta: { title: '配件录入' } },
      { path: 'accessory-list', component: () => import('../views/AccessoryList.vue'), meta: { title: '配件列表' } },
      { path: 'rental-out', component: () => import('../views/RentalOut.vue'), meta: { title: '产品出库' } },
      { path: 'rental-in', component: () => import('../views/RentalIn.vue'), meta: { title: '产品入库' } },
      { path: 'out-list', component: () => import('../views/OutList.vue'), meta: { title: '出库列表' } },
      { path: 'in-list', component: () => import('../views/InList.vue'), meta: { title: '入库列表' } },
      { path: 'price-settings', component: () => import('../views/PriceSettings.vue'), meta: { title: '价格设置' } },
      { path: 'user-settings', component: () => import('../views/UserSettings.vue'), meta: { title: '人员设置' } },
    ]
  }
];

const router = new VueRouter({ routes });

// 导航守卫：未登录强制跳登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.path !== '/login' && !token) {
    return next('/login');
  }
  if (to.path === '/login' && token) {
    return next('/dashboard');
  }
  next();
});

export default router;
